import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ArticleVO } from '@article/model/vo/article.vo';
import { Vector3 } from 'three';

export class CompositeArticleContainer {

  private _articleContainers: ArticleContainer[] = [];

  public get articleContainers(): readonly ArticleContainer[] {
    return this._articleContainers;
  }

  constructor(public article: ArticleVO) {
  }

  public addArticleContainer(articleContainer: ArticleContainer): void {
    this._articleContainers.push(articleContainer);
  }

  /**
   * Gets the minimum position of all article containers in this composite article container.
   */
  public get position(): Vector3 {
    const x = Math.min(...this.articleContainers.map((articleContainer) => articleContainer.position.x));
    const y = Math.min(...this.articleContainers.map((articleContainer) => articleContainer.position.y));
    const z = Math.min(...this.articleContainers.map((articleContainer) => articleContainer.position.z));
    return new Vector3(x, y, z);
  }

  public setArticleVisibility(value: boolean): void {
    for (const articleContainer of this.articleContainers) {
      articleContainer.setArticleVisibility(value);
    }
  }

  public show(): void {
    for (const articleContainer of this.articleContainers) {
      articleContainer.show();
    }
  }

  public hide(): void {
    for (const articleContainer of this.articleContainers) {
      articleContainer.hide();
    }
  }

  public get connections() {
    return this._articleContainers.flatMap((articleContainer) => articleContainer.connections);
  }

  public get articleGUID() {
    return this._articleContainers[0].articleGUID;
  }
}
